module.exports = __webpack_public_path__ + "img/phone.be9c7011.svg";